import ClaimStep from './claimStep'
import classname from 'classnames/bind'
import { Text, constants } from '@adc/ui-adc'
import house_icon from '../../assets/house_icon.svg'
import avoid_foreclosure_icon from '../../assets/avoid_foreclosure_icon.svg'
import calendar_check_mark_icon from '../../assets/calendar_check_mark_icon.svg'
import styles from './styles.scss'

const { ColorNames } = constants
const cx = classname.bind(styles)
interface StepData {
  icon: string
  title: string | JSX.Element
  description: string
}
const ClaimProcess = () => {
  const stepsData: StepData[] = [
    {
      icon: house_icon,
      title: (
        <>
          Update detail about
          <br /> your property
        </>
      ),
      description:
        'Provide information to help us understand your property’s value and potential.',
    },
    {
      icon: calendar_check_mark_icon,
      title: (
        <>
          Choose how and
          <br /> when to sell
        </>
      ),
      description:
        'Explore auction or traditional sale options that work with your timeline.',
    },
    {
      icon: avoid_foreclosure_icon,
      title: (
        <>
          Avoid foreclosure with
          <br /> professional guidance
        </>
      ),
      description:
        'Get expert support to navigate your options and protect your financial future',
    },
  ]

  return (
    <div className={cx('main-claiming-process-container')}>
      <div className={cx('header-section')}>
        <Text.Header level={1} color={ColorNames.GrayDark}>
          What "Claiming" Means
        </Text.Header>
        <Text color={ColorNames.Gray} size='large' weight='normal'>
          Take control of your situation with professional guidance and flexible
          options.
        </Text>
      </div>

      <div className='divider'></div>

      <div className={cx('claim-container')}>
        {stepsData.map((step, index) => (
          <div className={cx('claim-column')} key={index}>
            <ClaimStep
              icon={step.icon}
              title={step.title}
              description={step.description}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default ClaimProcess
